// Shared focus / scroll helpers. The selector chain is Add_Loan's (the most
// complete of the three copies), in its original order.

const safeQuery = (selector) => {
  try {
    return document.querySelector(selector);
  } catch (e) {
    // Raw server names such as `contacts[0].email` are not valid selectors.
    return null;
  }
};

/**
 * Scroll to and focus a field after `delay` ms. getElementById must stay first:
 * it is what makes `quote-firm-1` win over `quote-firm-10` (LLD §3.3).
 */
export function focusField(fieldId, { delay = 50 } = {}) {
  if (!fieldId) return;
  window.setTimeout(() => {
    const element =
      document.getElementById(fieldId) ||
      safeQuery(`[name="${fieldId}"]`) ||
      safeQuery(`[id^="${fieldId}"] input`) ||
      safeQuery(`#formcontrol${fieldId} input`) ||
      safeQuery(`#formcontrol${fieldId} [role="button"]`);

    if (element?.scrollIntoView) {
      element.scrollIntoView({ behavior: "smooth", block: "center" });
    }

    if (element?.focus) {
      element.focus();
    }
  }, delay);
}

export const sectionDomId = (prefix, id) =>
  `${prefix}-section-${String(id).replace(/\s+/g, "-").toLowerCase()}`;

/**
 * Scroll a section anchor into view. `beforeScroll` runs synchronously (e.g.
 * ensureSectionExpanded); the delay lets an accordion open first.
 */
export function scrollToSection(domId, { beforeScroll, delay = 80 } = {}) {
  if (beforeScroll) beforeScroll();
  window.setTimeout(() => {
    const element = document.getElementById(domId);
    if (element?.scrollIntoView) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, delay);
}
